module.exports = __webpack_public_path__ + "gd.8f560e9cd202b592a68b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gd.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gd.svg
// module chunks = styles